module.exports = __webpack_public_path__ + "static/media/icon_bank_account.4d8ca47c.png";